import { Deserializable } from "../../common/deserializable";

export class Pays implements Deserializable {
  id: number;
  nom: string;
  locode: string;

  constructor(id, nom, locode) {
    this.id = id;
    this.nom = nom;
    this.locode = locode;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/port/model/pays.ts